import icons from '../../../../shared/utils/files/antIcons';
import getMess from '../translations';

import { ItemTypes } from '../../constants/constants';

const label = 'previewFile';

function handler(apiOptions, actions) {
  const { showDialog, getSelectedResources, getResourceUrl, hideDialog, rootContainer } = actions;

  const getMessage = getMess.bind(null, apiOptions.locale);

  const resource = getSelectedResources()[0];

  const rawDialogElement = {
    elementType: 'PreviewFileDialog',
    elementProps: {
      onHide: hideDialog,
      rootContainer: rootContainer,
      headerText: getMessage('previewFile'),
      getResourceUrl: async () => {
        const res = await getResourceUrl(apiOptions, resource.id);
        // return res.data;

        return {
          url: res.data.url,
          contentType: res.data.contentType,
          name: res.data.fileName,
          size: resource.size,
        };
      },
    },
  };

  showDialog(rawDialogElement);
}

export default (apiOptions, actions) => {
  const localeLabel = getMess(apiOptions.locale, label);
  const { getSelectedResources } = actions;
  return {
    id: label,
    icon: { icon: icons.book },
    label: localeLabel,
    shouldBeAvailable: (apiOptions) => {
      const selectedResources = getSelectedResources();

      return selectedResources.length === 1 && selectedResources.every((r) => r.type === ItemTypes.File);
    },
    availableInContexts: ['row', 'toolbar'],
    handler: () => handler(apiOptions, actions),
  };
};
